import { render, staticRenderFns } from "./FakturPajakVendorAdd.vue?vue&type=template&id=3dc48680&scoped=true"
import script from "./FakturPajakVendorAdd.vue?vue&type=script&lang=js"
export * from "./FakturPajakVendorAdd.vue?vue&type=script&lang=js"
import style0 from "./FakturPajakVendorAdd.vue?vue&type=style&index=0&id=3dc48680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc48680",
  null
  
)

export default component.exports